import React, { createContext, useContext } from 'react';
import useElementListPlaceholdersState, { ListPlaceholdersProps } from './useElementListPlaceholdersState';

const ListPlaceholderContext = createContext<ListPlaceholdersProps>({
    saveCurrentListPlaceholderState: () => {},
    generateInitialElementsVisibility: () => {},
    getListInitialRenderSize: () => 0,
    allowElementPlaceholder: false,
    onElementVisibilityChange: () => {},
    savedPlaceholderMeasurementsRef: { current: null },
    initialElementsVisibilityMap: new Map(),
});

export const useListPlaceholderContext = () => useContext(ListPlaceholderContext);

type Props = {
    children: React.ReactNode;
    retainPreviousVisibleElements?: boolean;
};

const ListPlaceholderContextProvider = ({ children, retainPreviousVisibleElements }: Props) => {
    const listPlaceholderContextValue = useElementListPlaceholdersState(retainPreviousVisibleElements);

    return (
        <ListPlaceholderContext.Provider value={listPlaceholderContextValue}>
            {children}
        </ListPlaceholderContext.Provider>
    );
};

export default ListPlaceholderContextProvider;
